import React from "react"
import { Form } from "formik"
import { Button, TrashIcon28 } from "@unlimint/admin-ui-kit"

import { useTranslate } from "infrastructure/hooks/useTranslate"

import { InputField } from "view/components/formik/InputField"
import { CheckboxField } from "view/components/formik/CheckboxField"
import { SelectField } from "view/components/formik/SelectField"

import * as S from "./styled"

export const AddWebhookForm = ({
  title,
  actionButtonTitle,
  isSubmitting,
  values,
  onClose,
  errors,
  disabled,
  eventOptions,
  webhookEvents,
  setValues,
}) => {
  const close = useTranslate("pages.webhooks.modals.close")
  const url = useTranslate("pages.webhooks.modals.url")
  const name = useTranslate("pages.webhooks.modals.name")
  const headers = useTranslate("pages.webhooks.modals.headers")
  const headerName = useTranslate("pages.webhooks.modals.headerName")
  const headerValue = useTranslate("pages.webhooks.modals.headerValue")
  const headerAdd = useTranslate("pages.webhooks.modals.headerAdd")
  const version = useTranslate("pages.webhooks.modals.version")
  const versionPlaceholder = useTranslate(
    "pages.webhooks.modals.versionPlaceholder"
  )
  const isActive = useTranslate("pages.webhooks.modals.isActive")
  const webhookEventLabel = useTranslate(
    "pages.webhooks.modals.webhookEventLabel"
  )

  const handleAddHeaderRow = () => {
    values.headers.push({ name: "", value: "", id: Date.now().toString() })
    setValues({
      ...values,
    })
  }

  const deleteHeader = (id: string) => {
    const newHeaders = values.headers.filter((item) => item.id !== id)
    setValues({
      ...values,
      headers: newHeaders,
    })
  }

  return (
    <Form>
      <S.Wrapper>
        <S.Title>{title}</S.Title>

        <S.FormRow>
          <CheckboxField label={isActive} name="isActive" disabled={disabled} />
        </S.FormRow>

        <S.FormRow>
          <InputField label={name} name="name" disabled={disabled} />
        </S.FormRow>

        <S.FormRow>
          <InputField label={url} name="url" disabled={disabled} />
        </S.FormRow>

        <S.FormRow>
          <S.CheckboxGroupLabel>{headers}</S.CheckboxGroupLabel>
          {!!values.headers.length && (
            <S.ReqHeaderRow>
              <span>{headerName}</span>
              <span>{headerValue}</span>
            </S.ReqHeaderRow>
          )}
          {values.headers.map((item, idx) => {
            return (
              <S.ReqHeaderRow key={item.id}>
                <InputField name={`headers.${idx}.name`} disabled={disabled} />
                <InputField name={`headers.${idx}.value`} disabled={disabled} />
                <TrashIcon28
                  onClick={() => deleteHeader(item.id)}
                  width={21}
                  height={21}
                />
              </S.ReqHeaderRow>
            )
          })}
          {errors?.headers && (
            <S.HeadersError>{errors?.headers}</S.HeadersError>
          )}
          <Button size="small" onClick={handleAddHeaderRow} disabled={disabled}>
            {headerAdd}
          </Button>
        </S.FormRow>

        <S.FormRow>
          <SelectField
            label={version}
            name="apiVersion"
            options={eventOptions}
            placeholder={versionPlaceholder}
          />
        </S.FormRow>

        <S.FormRow>
          <S.CheckboxGroupLabel>{webhookEventLabel}</S.CheckboxGroupLabel>
          <S.CheckboxGroupList>
            {webhookEvents.data[values.apiVersion].map((webhookEvent) => {
              return (
                <CheckboxField
                  key={webhookEvent}
                  label={webhookEvent}
                  name="events"
                  value={webhookEvent}
                  disabled={disabled}
                />
              )
            })}
          </S.CheckboxGroupList>
          <S.EventsError>{errors?.events}</S.EventsError>
        </S.FormRow>

        <S.Buttons>
          <Button
            size="small"
            variant="outlined"
            onClick={onClose}
            disabled={disabled}
          >
            {close}
          </Button>
          <Button
            size="small"
            type="submit"
            disabled={isSubmitting || disabled}
          >
            {actionButtonTitle}
          </Button>
        </S.Buttons>
      </S.Wrapper>
    </Form>
  )
}
